import Raven from 'raven-js';
// @ts-expect-error untyped-file
import { getId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getSessionId } from '../../selectors/widgetDataSelectors/getSessionId';
import { recordCustomerAgentDeliveryReceipt } from '../../threads/clients/recordCustomerAgentDeliveryReceipt';
export const trackLlmMessageReceived = ({
  message,
  threadId
}) => (_dispatch, getState) => {
  const messageId = getId(message);
  const sessionId = getSessionId(getState());
  if (!messageId || !sessionId) {
    return;
  }
  recordCustomerAgentDeliveryReceipt({
    threadId,
    messageId,
    sessionId
  }).catch(error => {
    Raven.captureException(new Error('recordCustomerAgentDeliveryReceipt failed'), {
      extra: {
        threadId,
        messageId,
        sessionId,
        originalErrorMessage: error === null || error === void 0 ? void 0 : error.message
      }
    });
  });
};